import React from "react"
import { useNavigate } from "react-router-dom"
import { ButtonProps } from "./ButtonProps"

const PrimaryButton: React.FC<ButtonProps> = ({
  label,
  icon,
  to,
  onClick,
  className = "",
  type = "button",
  disabled = false
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (to) {
      navigate(to)
    } else if (onClick) {
      onClick()
    }
  }

  return (
    <button disabled={disabled} type={type} onClick={handleClick} className={`primaryButton com-button ${className}`}>
      {icon && <span className='icon me-1'>{icon}</span>}
      {label}
    </button>
  )
}

export default PrimaryButton
